module.exports = __webpack_public_path__ + "img/cloudview_service-overlay-1.ec64032a.jpg";